import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import AdminMenu from "../../AdminMenu";
import { getAllPaymentModeByBrandId } from "../../../services/paymentMode/paymentMode";

const SECTIONS = [
  { key: "all", title: "All Payment Modes", subtitle: "Enabled for your brand", color: "#1752AA" },
  { key: "Location1", title: "Orders", subtitle: "Used while placing orders", color: "#0E7C6B" },
  { key: "Location2", title: "Subscription", subtitle: "Used for subscription payments", color: "#7A4CC2" },
  { key: "Location3", title: "Rider", subtitle: "Collected by riders", color: "#C26A1B" },
];

const PaymentModeList = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);
  const [paymentModeList, setPaymentModeList] = useState(null);

  const fetchPaymentMode = (brandId) => {
    setLoading(true);
    getAllPaymentModeByBrandId(brandId)
      .then((response) => {
        if (!response.data.error) {
          setPaymentModeList(response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchPaymentMode(brandId);
  }, []);

  const modes = paymentModeList?.paymentModes || [];
  const sectionModes = (key) =>
    key === "all" ? modes : paymentModeList?.paymentModeList?.[key] || [];

  const goToEdit = (item) => navigate("/PaymentModeCreate", { state: { item } });

  const renderSection = ({ key, title, subtitle, color }) => {
    const data = sectionModes(key);
    return (
      <div key={key} className="col-12 sm:col-6 lg:col-3 p-1">
        <div
          className="h-full surface-card border-round-lg shadow-1 px-3 py-2"
          style={{ borderLeft: `5px solid ${color}` }}
        >
          <div className="flex align-items-center justify-content-between">
            <div>
              <p className="m-0 text-lg font-bold text-900">{title}</p>
              <p className="m-0 text-sm text-600">{subtitle}</p>
            </div>
            <span
              className="text-base font-bold border-round-2xl px-2"
              style={{ background: `${color}1A`, color }}
            >
              {data.length}
            </span>
          </div>

          <div className="flex flex-wrap gap-2 mt-2">
            {data.length > 0 ? (
              data.map((item, index) => (
                <span
                  key={index}
                  className="text-base font-medium capitalize border-round-2xl px-3 py-1"
                  style={{ background: `${color}14`, color: "#1F2937" }}
                >
                  {item}
                </span>
              ))
            ) : (
              <span className="text-base text-500">No mode added</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1" style={{ background: "#F4F6F8", minHeight: "100vh" }}>
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Payment Mode
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="p-2">
        {loading ? (
          <div className="text-center pt-6">
            <ProgressSpinner
              style={{ width: "70px", height: "70px" }}
              strokeWidth="4"
              fill="var(--surface-ground)"
              animationDuration="2s"
            />
          </div>
        ) : modes.length > 0 ? (
          <>
            <div className="flex align-items-center justify-content-between px-1 pb-1">
              <p className="m-0 text-base text-700">
                 
              </p>
              <button
                onClick={() => goToEdit(paymentModeList)}
                className="flex align-items-center border-none border-round-3xl px-3 py-1 cursor-pointer text-white text-base font-semibold"
                style={{ background: "#2B70D7" }}
              >
                <i className="pi pi-pencil mr-2"></i>
                Edit
              </button>
            </div>
            <div className="grid m-0">{SECTIONS.map(renderSection)}</div>
          </>
        ) : (
          <div className="flex flex-column align-items-center justify-content-center text-center pt-8">
            <i className="pi pi-wallet text-500" style={{ fontSize: 56 }}></i>
            <p className="m-0 mt-3 text-2xl font-bold text-900">No Payment Mode Found</p>
            <p className="m-0 mt-2 text-lg text-600">
              Add the payment modes your customers can use.
            </p>
            <button
              onClick={() => goToEdit(null)}
              className="flex align-items-center border-none border-round-3xl px-5 py-3 mt-4 cursor-pointer text-white text-lg font-semibold"
              style={{ background: "#2B70D7" }}
            >
              <i className="pi pi-plus mr-2"></i>
              Add Payment Mode
            </button>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PaymentModeList;
